import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'semantic-ui-react/dist/commonjs/modules/Checkbox';

class InputCheckbox extends React.PureComponent {
  static propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func,
    title: PropTypes.string,
  };

  handleChange = (event, { checked, name }) => {
    const { onChange } = this.props;
    onChange(event, { name, value: checked });
  }

  render() {
    const { value, ...rest } = this.props;
    return (
      <Checkbox
        {...rest}
        data-cy="academic-filters-enabled-checkbox"
        checked={value}
        onChange={this.handleChange}
      />
    );
  }
}

export default InputCheckbox;
